// src/components/ProtectedRoute.jsx

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase';
import CatholicoreLogo from '../../assets/Catholicore_inline_transparent.png';

const ProtectedRoute = ({ children }) => {
  const [user, loading, error] = useAuthState(auth);

  return (
    <>

      {/* Delay rendering the children or redirect until the spinner has finished */}
      {!loading && !user && <Navigate to="/" replace />}

      {!loading && user && children}
    </>
  );
};

export default ProtectedRoute;
